import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import asyncMiddleware from './asyncMiddleware';
import trackingMiddleware from './trackingMiddleware';
import socketMiddleware from './socketMiddleware';
import ApiClient from 'lib/ApiClient';
import axios from 'axios';
import createHashHistory from 'history/createHashHistory';
import rootReducer from './modules';
import clientId from 'utils/clientid';
import loggerMiddleware from 'redux-logger';
import { HTTP_API_URL, HTTP_MLS_API_URL, SEGMENT, SOCKET_URL } from 'config';
import { loadSegment } from '../lib/Segment';

let confirmationFn = null;

export const history = createHashHistory({
	hashType: 'noslash',
	getUserConfirmation(message, callback) {
		if (confirmationFn) {
			confirmationFn(message, callback);
		} else {
			callback(true);
		}
	}
});

export const setConfirmationFunction = function (fn) {
	confirmationFn = fn;
};

const initialState = {};
const enhancers = [];
const middleware = [
	asyncMiddleware(new ApiClient(HTTP_API_URL, HTTP_MLS_API_URL, clientId), axios),
	routerMiddleware(history),
	socketMiddleware(SOCKET_URL, clientId)
];

if (SEGMENT) {
	loadSegment();
	middleware.push(trackingMiddleware);
}

if (process.env.NODE_ENV === 'development') {
	const devToolsExtension = window.devToolsExtension;
	if (typeof devToolsExtension === 'function') {
		enhancers.push(devToolsExtension());
	}
	middleware.push(loggerMiddleware);
}

let reduxMiddleware = applyMiddleware(...middleware);

const composedEnhancers = compose(
	reduxMiddleware,
	...enhancers
);

const store = createStore(
	rootReducer,
	initialState,
	composedEnhancers
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js